<template>
  <div class="container-custom">
    <v-form ref="form" @submit.prevent="saveHandler">
      <Breadscrumbs
        :links="[
          {
            name: 'StoryCenter',
            to: {
              name: 'StoryCenter'
            }
          },
          {
            name: 'Create',
            to: {
              name: 'StoryCreate',
            }
          }
        ]"
      ></Breadscrumbs>
      <!-- page-actions -->
      <div class="page-actions">
        <h2>新增案例</h2>
        <v-spacer></v-spacer>
        <button class="btn mr-5" @click="cancelHandler">
          <span>取消</span>
        </button>
        <button class="btn btn-primary" type='submit'>
          <span>儲存</span>
        </button>
      </div>
    </v-form>
    <!-- Block 新增案例 -->
    <StoryCreateEdit></StoryCreateEdit>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import StoryCreateEdit from '@/views/E-5__SuccessStory/c/StoryCreateEdit.vue';

export default {
  components: {
    Breadscrumbs,
    StoryCreateEdit,
  },
  computed: {
    ...mapState('story', ['story']),
  },
  created() {
    this.setStory({});
  },
  methods: {
    ...mapActions('story', ['setStory', 'save']),
    cancelHandler() {
      this.$router.push({ name: 'StoryCenter' });
    },
    saveHandler() {
      this.errors = [];
      if (this.$refs.form.validate()) {
        if (!this.story.title) {
          this.errors.push('標題 required.');
        } else if (!this.story.bu_application_details_id) {
          this.errors.push('應用[Application] required.');
        } else if (!this.story.slug) {
          this.errors.push('Slug required.');
        }
        if (this.errors.length > 0) {
          /* eslint-disable */
          alert(this.errors);
          /* eslint-disable */
          return false;
        }
        this.save(this.story).then(() => {
          this.$router.push({ name: 'StoryCenter' });
        });
      }
    },
  },
};
</script>

<style></style>
